module.exports = __webpack_public_path__ + "img/thank-img.ad6df4f1.png";